import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  CenturyLink,
  QuantumFiber,
  Earthlink,
  Frontier,
  Windstream,
  CincinnatiBell,
} from 'config/providers';
import { ATTTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/TVI-1047
export const AdActionATTPartner: SingleProviderConfig = {
  name: 'AdActionATTPartner',
  micrositeCode: 'adactionattpartner',
  mainProvider: ATT,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'attspecial.com',
  homepage: 'https://attspecial.com',
  title: 'AT&T Authorized Dealer',
  fallbackPhoneNumber: '844-806-6187',
  fallbackLeadModePhoneNumber: '844-820-1562',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: ATTTheme,
  needsDcSession: false,
  source: 'ATT',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    CenturyLink,
    QuantumFiber,
    CincinnatiBell,
    Earthlink,
    Frontier,
    Windstream,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    CenturyLink,
    QuantumFiber,
    CincinnatiBell,
    Earthlink,
    Frontier,
    Windstream,
  ],
};
